export default "__VITE_ASSET__u7xIx_Mo__"